import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function WorkOrdersViewModel(logout, addSnackbar) {
  const defaultFilters = {
    customer: { value: -1, label: "All customers" },
    employee: { value: -1, label: "All employees" },
    status: { value: -1, label: "All invoices" },
    startDate: null,
    endDate: null,
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [workOrders, setWorkOrders] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getWorkOrders = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: filters,
    };
    let callResult = await makePostApiCall(`workOrdersForEmployee`, payload);
    setLoading(false);
    if (callResult.success) {
      setWorkOrders(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const deleteWorkOrder = async function (workOrderId, index) {
    let callResult = await makePostApiCall(
      `deleteWorkOrder/${workOrderId}`,
      {}
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getWorkOrders(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteWorkOrder = function (workOrder, index) {
    if (workOrder.status === 5 || workOrder.status === 11) {
      showErrorModal("Shipped or voided workOrders cannot be deleted");
    } else {
      setEmptyModelOpen({
        childComponent: (
          <DeleteConfirmationForm
            buttonMessage="Delete"
            confirmAction={() => deleteWorkOrder(workOrder.id, index)}
            message={`Are you sure you want to delete ${workOrder.po_number} for ${workOrder.customer_name}?`}
            setOpen={setEmptyModelOpen}
            hideReason={true}
          />
        ),
        open: true,
      });
    }
  };

  const filterComponents = [
    <DateRangeFilter
      startDate={filters.startDate}
      endDate={filters.endDate}
      onChange={(name, value) =>
        setFilters({
          ...filters,
          [name]: value,
        })
      }
      resetFilter={() => setFilters(defaultFilters)}
    />,
    <FilterSingleSelectDropdown
      header="Customer"
      onChange={(value) =>
        setFilters({
          ...filters,
          customer: value,
        })
      }
      options={customers}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="customer"
      value={filters.customer}
    />,
    <FilterSingleSelectDropdown
      header="Employee"
      onChange={(value) =>
        setFilters({
          ...filters,
          employee: value,
        })
      }
      options={employees}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="employee"
      value={filters.employee}
    />,
    <FilterSingleSelectDropdown
      header="Status"
      onChange={(value) =>
        setFilters({
          ...filters,
          status: value,
        })
      }
      options={customers}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="status"
      value={filters.status}
    />,
  ];

  const resetFilters = () => {
    const filterReset = {
      customer: { value: -1, label: "All customers" },
      startDate: null,
      endDate: null,
    };
    setFilters(filterReset);

    setShowFilters(false);
    getWorkOrders(null, 1, filterReset);
  };

  const getCustomers = async function () {
    let callResult = await makeGetApiCall(`customersForDropdown`);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getEmployeesForDropdown = async function () {
    let callResult = await makeGetApiCall(`usersForDropdown`);
    if (callResult.success) {
      setEmployees(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return {
    askDeleteWorkOrder,
    emptyModal,
    getWorkOrders,
    loading,
    workOrders,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    filters,
    showFilters,
    setShowFilters,
    filterComponents,
    resetFilters,
    getCustomers,
    getEmployeesForDropdown,
  };
}
